import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as wjcCore from '@grapecity/wijmo';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Store } from '@ngrx/store';
import { LayoutState } from './layout/store';
import { LoadPermissions } from '../app/store/actions/app.actions';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LayoutService } from 'src/app/core/services/layout.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  @ViewChild('sessionModal', { static: false }) sessionModalIdentifier: ElementRef;
  userAccountDetails: any;
  isBusyLoader: boolean;
  constructor(private router: Router,
    private store: Store<LayoutState>,
    private idle: Idle,
    private keepalive: Keepalive,
    private modalService: NgbModal,
    private layoutService: LayoutService) {
  }

  idleInit() {
    // sets a timeout period in seconds, after inactivity timeout, the user will be considered with session expired.
    let timeout;
    let sessionTimeoutVal;
    this.layoutService.getUserAccount().subscribe(responseValue => {
      this.userAccountDetails = responseValue;
      sessionTimeoutVal = this.userAccountDetails.idleSessionTimeoutMinutes;

      if (this.userAccountDetails) {

        if (sessionTimeoutVal == null || sessionTimeoutVal === undefined || sessionTimeoutVal === '') {
          timeout = environment.defaultTimeOutValue;
        } else {
          timeout = sessionTimeoutVal;
        }

        this.idle.setIdle(5);
        this.idle.setTimeout(timeout * 60);

        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onTimeout.subscribe(() => {
          this.idleState = 'Timed out!';

          this.modalService.open(this.sessionModalIdentifier).result.then(result => {
            if (result === 'confirm') {
              if (localStorage.getItem('show-ciam-login') === "True") {
                window.top.location.href = environment.strrooturl + 'auth/Logout';
              }
              else {
                window.top.location.href = environment.strrooturl + 'login/';
              }
            }
          });
        });

        // sets the ping interval to 15 seconds
        this.keepalive.interval(15);
        this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
        this.reset();
      }
    });
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  ngOnInit(): void {
    wjcCore.setLicenseKey('TR,953549429285442#B0ARwxWU6NzdBpldklnYmZWO4d5b4Z7RDRnds5WT5p5U4BXdGh5YXhFUTBHRLREM4EDONl7TzVnN6Z5c5lWY7RkSShnU8dUVwdncrQHNmh4aqRkeqtSV9pkVYhGOxZjaRpXRPZUNXZHUQdTRG9kVktSWK96bPBHeZRGOygmQTljNHJHaLJ5amlHS7MURYR4cNZkYtlVaMN6a6IXZ7gXWzQFOmd4VDpleDdVduR6UGhnQKRjekhEUydUd7QnMvYVVQZTeRRWMl3Gc9EkawpXSxJnaVtkbTpENrZEVXl4bkVkYWZVa7JkRSRTcX5URFhVOFNzNGJTMVNHV9AFOKlncFRUS9Qmb5YTd6ZmM5lnV4tSVvklY7YnR6xmUuFEWPhEZlNTcINkZ7xWMWNkWJ3ETYN6dO56QMNTM8g4YxYXOPNjWZ3yKYpUTWFGV5ElWzxWNv8WSndkI0IyUiwiIGREM5YkNCNjI0ICSiwyNycTM5gTM9UTM0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLigDNyUjNwAiMwITM9EDMyIiOiQncDJCLiIFViojIh94QiwiIyQDN5gjM9IDN9QTNzUTOiojIklkIs4nIzYXOxAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34QQtx');
    let queryString = localStorage.getItem("urlQuery");
    let routeParameters: any = {};
    if (queryString) {
      let query = queryString.split('&');
      routeParameters = query.reduce((parameters, current) => {
        let value = current.split('=');

        if (value[0] !== '') {
          parameters[value[0]] = value[1];
        }

        return parameters;
      }, {})
    }

    // Mobilize-Note: osalazar. Route should be set in ASP.
    let route = routeParameters && routeParameters.route ? routeParameters.route : localStorage.getItem("route")
    console.log('Route', route, routeParameters);

    if (Object.keys(route).length != 0) {
      this.router.navigate(['/' + route, routeParameters]);
      this.store.dispatch(LoadPermissions());
      if (route == "dashboard" && localStorage.getItem("isNotificationSet") == "true") {
        this.router.navigate(['/dashboard/no-header-canvas/my-notifications']);
      }

      //init has moved here since only when routing and showing components from Angular, user will interact directly with them.
      //subscription will happen only into this condition and not in pages where route is not getting solved.
      //for this reason, when user is interacting with classic html elements, it's not monitoring the interrupts.
      this.idleInit();
    }
  }
}
